import gql from 'graphql-tag';

import GraphQLClient from '../../adapter/GraphQLClient';
import { CreateDeliverableMutation } from '../../graphql/generated/graphql';

class DeliverableWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public createDeliverable = async (
    assignmentId: string,
    creativeFormatId: string,
    fileId: string,
    attachedThumbnailId: string | null,
    intent: string,
  ): Promise<NonNullable<CreateDeliverableMutation['createDeliverable']>> => {
    const result: CreateDeliverableMutation = await this.graphqlClient.query(
      gql`
        mutation createDeliverable(
          $assignmentId: ID!
          $creativeFormatId: ID!
          $fileId: ID!
          $attachedThumbnailId: ID
          $intent: String!
        ) {
          createDeliverable(
            assignmentId: $assignmentId
            creativeFormatId: $creativeFormatId
            fileId: $fileId
            attachedThumbnailId: $attachedThumbnailId
            intent: $intent
          ) {
            id
            creationId
            creative {
              id
              file {
                id
                originalFileName
                url
                mimeType
                size
                attribute {
                  aspectRatio {
                    size {
                      width
                      height
                    }
                  }
                  playbackTime {
                    seconds
                  }
                }
              }
            }
            attachedThumbnail {
              id
              file {
                id
                originalFileName
                url
                mimeType
                size
                attribute {
                  aspectRatio {
                    size {
                      width
                      height
                    }
                  }
                  playbackTime {
                    seconds
                  }
                }
              }
            }
            intent
            state
            createdAt
            stateUpdatedAt
          }
        }
      `,
      { assignmentId, creativeFormatId, fileId, attachedThumbnailId, intent },
    );

    if (result.createDeliverable) {
      return result.createDeliverable;
    } else {
      throw new Error('createDeliverable is blank');
    }
  };
}

export default DeliverableWebApi;
